import constants from '../Constants';
import { filter } from 'lodash';
const {
    GET_LOCATIONS,
    LOCATIONS_LOADING,
    ADD_LOCATION,
    ADD_LOCATION_FAIL,
    UPDATE_LOCATION,
    UPDATE_LOCATION_FAIL,
    DELETE_LOCATION,
    ADD_SUBLOCATION,
    ADD_SUBLOCATION_FAIL,
    DELETE_SUBLOCATION,
    RESET_LOCATIONS_ALERT,
    LOGOUT
} = constants;

const INIT_STATE = {
  locations:{},
  locationsMeta:{lastPage: false, total: false, currentPage: 1, perPage: 20},
  query: {},
  locationsLoading: true,
  alert: { subLocations_alert: false, add: false, edit: false, delete: false, get: false },
};

const LocationReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LOCATIONS:
      const { data, query } = action.payload;
      const { entities, result } = data;
      return { 
            ...state, 
            locations: entities.locations, 
            locationsMeta: {
                total: result.total,
                currentPage: result.current_page,
                perPage: result.per_page,
                lastPage: result.last_page,
                data: result.data,
            },
            locationsLoading: false,
            query: query,
        };

        case LOCATIONS_LOADING:
        return {
            ...state, locationsLoading: true,
        };
    
    case DELETE_LOCATION:

        const { locationsMeta, locationsMeta: { data: metaData } } = state;

        const { [action.payload.toString()]: removed, ...rest } = state.locations;
        
        metaData.splice(metaData.indexOf(action.payload), 1);
        
        const newMeta = { ...locationsMeta, data: metaData };
        
        return { ...state, locations: rest, locationsMeta: newMeta, alert: INIT_STATE.alert };

    case ADD_LOCATION:

        return {
            ...INIT_STATE,
            alert: { ...INIT_STATE.alert, add: {type: "success", message: "Location added successfully." }},
        };

    case ADD_SUBLOCATION:
    
    const { location_id, subLocation } = action.payload;

    const { sub_locations = [] } = state.locations[location_id];
    
    const newData = [...sub_locations, subLocation ];
    
    const newLocation = {...state.locations[location_id], sub_locations: newData};
    
    const changedLocations = {...state.locations, [location_id]: newLocation};
    
    return {
        ...state, locations: changedLocations,
        alert: { ...INIT_STATE.alert, subLocations_alert: {type: "success", message: "Sub Location added successfully." }}
    };

    case DELETE_SUBLOCATION:
        
        const { id:sub_location_id, location_id: lid } = action.payload;
        
        const { sub_locations: old_sub_locations } = state.locations[lid];
        
        const newSubLocations = filter(old_sub_locations, item => item.id !== sub_location_id);

        const newLocation1 = {...state.locations[lid], sub_locations: newSubLocations};

        const changedLocations1 = {...state.locations, [lid]: newLocation1};

        return {...state, locations: changedLocations1};
    
    case ADD_LOCATION_FAIL:
        return {
            ...state,
            alert: { ...INIT_STATE.alert, subLocations_alert: {type: "warning", message: action.payload }}
        };

    case ADD_SUBLOCATION_FAIL:
        return {
            ...state,
            alert: { ...INIT_STATE.alert, subLocations_alert: {type: "warning", message: action.payload }},
    };

    case UPDATE_LOCATION:
        const locations = {...state.locations,[action.payload.id]: action.payload};
        return {...state, locations,  alert: { ...INIT_STATE.alert, edit: {type: "success", message: "Location updated successfully." }}};

    case UPDATE_LOCATION_FAIL:
        return {
            ...state,
            alert: { ...INIT_STATE.alert, edit: {type: "warning", message: action.payload }},
        };

    case RESET_LOCATIONS_ALERT:
        return {
            ...state,
            alert: INIT_STATE.alert,
        };

    case LOGOUT:
        return INIT_STATE;
    
    default:
        return state;

    }
}

export default LocationReducer;


// WEBPACK FOOTER //
// ./src/Reducers/LocationReducer.js